import {Component, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {combineLatest, map, Observable, ReplaySubject, Subscription} from 'rxjs';
import {ApplicationStateService} from '../services/application.state.service';
import { VisualizeEngine } from '@door-vision/visualisation-engine';
import {ScenarioImageService} from '../services/scenario-image/scenario-image.service';
import {CustomerService} from '../services/customer/customer.service';
import {Title} from '@angular/platform-browser';
import { LogoPlacement } from '../models/customer.config';
import {RefinePanelComponent} from "../components/panels/desktop/refine-panel/refine-panel.component";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-desktop',
  templateUrl: './desktop.app.component.html',
  styleUrls: ['./desktop.app.component.scss']
})
export class DesktopAppComponent implements OnInit, OnDestroy {

  subs: Subscription[] = [];
  mousePosition$ = new ReplaySubject<MouseEvent>(1);
  isRefineActive$ = combineLatest([
    this.applicationStateService.isApplicationLoaded(),
    // TODO should we always show the refine panel?
    this.scenarioImageService.getSelected$().pipe(map(s => /*s.type === ScenarioType.USER*/ true)),
  ]).pipe(map(result => result.every(b => b)));
  isBrandingEnabled$ = this.customerService.getCustomerConfig$().pipe(map(config => config.isBrandingEnabled));
  logoUrl$ = this.customerService.getCustomerConfig$().pipe(map(config => config.logoUrl));

  @ViewChild('refinePanel')
  refinePanel: RefinePanelComponent | undefined;

  customerConfig$ = this.customerService.getCustomerConfig$();

  LogoPlacement = LogoPlacement;

  constructor(
    private visualizeEngine: VisualizeEngine,
    public applicationStateService: ApplicationStateService,
    private customerService: CustomerService,
    public route: ActivatedRoute,
    private scenarioImageService: ScenarioImageService,
    private title: Title) {
  }

  ngOnInit(): void {
    this.subs.push(this.customerService.getCustomerName$().subscribe(name => this.title.setTitle(name)));

    this.subs.push(combineLatest([this.visualizeEngine.getCurrentScenario(), this.mousePosition$]).subscribe(([scenario, mouse]) => {
      if (this.refinePanel) {
        if (scenario.boundsOnScreen.containsPoint(mouse.x, mouse.y)) {
          this.refinePanel.show();
        } else {
          this.refinePanel.hide();
        }
      }
    }));
  }

  @HostListener('mousemove', ['$event'])
  onMouseMove(event: MouseEvent): void {
    this.mousePosition$.next(event);
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }

  public getCustomerHomepageUrl(): Observable<string> {
    return this.customerService.getCustomerHomepageUrl()
  }

  protected readonly alert = alert;
}
